import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { Container } from "reactstrap";
import { Col, Row, Stack } from "react-bootstrap";
import { UnderConstruction } from "../../Component/UnderConstruction/UnderConstruction";
import { PageHeader } from "../../CommonElements/PageTitle";

const Dashboard = () => {
  const { t } = useTranslation();

  return (
    <Stack gap={2}>
      <PageHeader title={t("HOME")} />
      <Container fluid={true}>
        <Row className="justify-content-center" style={{ marginTop: "60px" }}>
          <Col xs={24} sm={20} md={16} lg={12} xl={10}>
            <UnderConstruction />
          </Col>
        </Row>
      </Container>
    </Stack>
  );
};
export default Dashboard;
